<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="cont" title="Contents">
<p class="h2f"><span class="right_1" epub:type="pagebreak" id="page_v" title="v">CONTENTS</span></p>
<p class="tocf0" id="ack"><a href="#/text/9780253044075_Acknowledgments"><i>Acknowledgments</i></a></p>
<p class="tocf0" id="name"><a href="#/text/9780253044075_Naming"><i>Note on Spelling and Naming</i></a></p>
<p class="tocf" id="int"><a href="#/text/9780253044075_Introduction">Introduction</a></p>
<p class="tocc" id="ch1"><a href="#/text/9780253044075_Chapter_1">1.<span class="spacect">The Land without Music (1899–1916)</span></a></p>
<p class="tocc" id="ch2"><a href="#/text/9780253044075_Chapter_2">2.<span class="spacect">Years of Study (1916–21)</span></a></p>
<p class="tocc" id="ch3"><span href="#/text/9780253044075_Chapter_3" title="Link target outside of Sample">3.<span class="spacect">Composer and Conductor (1921–29)</span></span></p>
<p class="tocc" id="ch4"><span href="#/text/9780253044075_Chapter_4" title="Link target outside of Sample">4.<span class="spacect">Leifs and the Elements of an Icelandic Style</span></span></p>
<p class="tocc" id="ch5"><span href="#/text/9780253044075_Chapter_5" title="Link target outside of Sample">5.<span class="spacect">Icelandic Nation-Building and the 1930 Alþingi Festival (1929–33)</span></span></p>
<p class="tocc" id="ch6"><span href="#/text/9780253044075_Chapter_6" title="Link target outside of Sample">6.<span class="spacect">“This Music Belongs to Us” (1933–37)</span></span></p>
<p class="tocc" id="ch7"><span href="#/text/9780253044075_Chapter_7" title="Link target outside of Sample">7.<span class="spacect">Dinosaurs in Berlin (1937–44)</span></span></p>
<p class="tocc" id="ch8"><span href="#/text/9780253044075_Chapter_8" title="Link target outside of Sample">8.<span class="spacect">Guilt and Retribution (1944–55)</span></span></p>
<p class="tocc" id="ch9"><span href="#/text/9780253044075_Chapter_9" title="Link target outside of Sample">9.<span class="spacect">The Final Years (1955–68)</span></span></p>
<p class="tocf1" id="pos"><span href="#/text/9780253044075_Postlude" title="Link target outside of Sample">Postlude: Revival and Influence</span></p>
<p class="tocf" id="app"><span href="#/text/9780253044075_Appendix" title="Link target outside of Sample"><i>Appendix: List of Jón Leifs’s Completed Works</i></span></p>
<p class="tocf0" id="bib"><span href="#/text/9780253044075_Bibliography" title="Link target outside of Sample"><i>Selected Bibliography</i></span></p>
<p class="tocf0" id="ind"><span href="#/text/9780253044075_Index" title="Link target outside of Sample"><i>Index</i></span><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253044075_Contents.vue?99300056